import { render, staticRenderFns } from "./UbicacionForm.vue?vue&type=template&id=0056a684&scoped=true"
import script from "./UbicacionForm.vue?vue&type=script&lang=js"
export * from "./UbicacionForm.vue?vue&type=script&lang=js"
import style0 from "./UbicacionForm.vue?vue&type=style&index=0&id=0056a684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056a684",
  null
  
)

export default component.exports